export const sk = {
    languages: {
        cs: 'Čeština',
        de: 'Nemčina',
        en: 'Angličtina',
        es: 'Španielčina',
        fr: 'Francúzština',
        hr: 'Chorvátčina',
        hu: 'Maďarčina',
        it: 'Taliančina',
        nl: 'Holandčina',
        pl: 'Poľština',
        ru: 'Ruština',
        sk: 'Slovenčina',
        tr: 'Turečtina',
        uk: 'Ukrajinčina',
        undefined: 'Bez titulkov',
    },
    player: {
        content: {
            notFound: { title: 'Chyba pri načítaní mediálneho prvku 😞' },
        },
        controls: {
            backwards: { title: '10s dozadu' },
            buffering: { title: 'Načítava sa...' },
            captions: { title: 'Titulky' },
            forwards: { title: '10s dopredu' },
            fullscreen: { title: 'Celá obrazovka' },
            pause: { title: 'Pauza' },
            play: { title: 'Prehrať' },
            playlist: { title: 'Playlist' },
            volume: { title: 'Hlasitosť' },
        },
    },
};
